(function() {
    'use strict';

    var previewCard = null;
    var currentLink = null;
    var showTimeout = null;
    var hideTimeout = null;
    var cache = {};
    var isLoading = false;

    var SHOW_DELAY = 300;
    var HIDE_DELAY = 200;

    function createPreviewCard() {
        var card = document.createElement('div');
        card.className = 'link-preview-card';
        card.innerHTML = '<div class="link-preview-loader"></div>';
        document.body.appendChild(card);
        return card;
    }

    function isInternalPostLink(link) {
        var href = link.getAttribute('href');
        if (!href) return false;

        var currentHost = window.location.hostname;
        var linkUrl;

        try {
            linkUrl = new URL(href, window.location.origin);
        } catch (e) {
            return false;
        }

        // Check if link is to the same host
        var isSameHost = linkUrl.hostname === currentHost;

        // Only allow internal links (same host)
        if (!isSameHost) return false;

        var pathname = linkUrl.pathname;
        var isPost = pathname.match(/^\/[^\/]+\/?$/) &&
                     !pathname.match(/^\/(tag|author|page|404|ghost)\//);

        return isPost && pathname !== window.location.pathname;
    }

    function fetchPostData(url) {
        if (cache[url]) {
            return Promise.resolve(cache[url]);
        }

        return fetch(url, {
            headers: {
                'Accept': 'text/html'
            }
        })
        .then(function(response) {
            if (!response.ok) throw new Error('Failed to fetch');
            return response.text();
        })
        .then(function(html) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(html, 'text/html');

            var title = doc.querySelector('meta[property="og:title"]');
            var publishedTime = doc.querySelector('meta[property="article:published_time"]');
            var modifiedTime = doc.querySelector('meta[property="article:modified_time"]');

            // Don't show image for internal blog posts
            var image = null;

            // Always extract content from the post body with HTML formatting
            var contentHtml = '';
            var content = doc.querySelector('.gh-content, .single-content, .post-content');
            if (content) {
                // Clone the content to avoid modifying the original
                var contentClone = content.cloneNode(true);

                // Remove unwanted elements (scripts, styles, etc.)
                var unwanted = contentClone.querySelectorAll('script, style, .gh-sidebar, .gh-toc, aside');
                unwanted.forEach(function(el) { el.remove(); });

                // Get the HTML of first few elements
                var elements = contentClone.children;
                var htmlParts = [];
                var totalLength = 0;

                for (var i = 0; i < elements.length && totalLength < 420; i++) {
                    var el = elements[i];
                    var elText = el.textContent || el.innerText || '';

                    if (elText.trim()) {
                        htmlParts.push(el.outerHTML);
                        totalLength += elText.length;
                    }
                }

                contentHtml = htmlParts.join('');
            }

            var data = {
                title: title ? title.getAttribute('content') : 'Untitled',
                descriptionHtml: contentHtml,
                image: image ? image.getAttribute('content') : null,
                publishedTime: publishedTime ? publishedTime.getAttribute('content') : null,
                modifiedTime: modifiedTime ? modifiedTime.getAttribute('content') : null,
                isTruncated: totalLength >= 420
            };

            cache[url] = data;
            return data;
        });
    }

    function formatDate(dateString) {
        if (!dateString) return '';

        var date = new Date(dateString);
        var options = { year: 'numeric', month: 'short', day: 'numeric' };
        return date.toLocaleDateString('en-US', options);
    }

    function updatePreviewCard(data) {
        var imageHtml = data.image
            ? '<div class="link-preview-image"><img src="' + data.image + '" alt=""></div>'
            : '';

        var dateHtml = '';
        if (data.publishedTime || data.modifiedTime) {
            dateHtml = '<div class="link-preview-dates">';
            if (data.publishedTime) {
                dateHtml += '<span class="link-preview-date">' + formatDate(data.publishedTime) + '</span>';
            }
            if (data.modifiedTime && data.modifiedTime !== data.publishedTime) {
                if (data.publishedTime) {
                    dateHtml += '<span class="link-preview-date-separator">•</span>';
                }
                dateHtml += '<span class="link-preview-date">Last updated ' + formatDate(data.modifiedTime) + '</span>';
            }
            dateHtml += '</div>';
        }

        var truncatedClass = data.isTruncated ? ' is-truncated' : '';

        previewCard.innerHTML =
            imageHtml +
            '<div class="link-preview-content">' +
                '<div class="link-preview-title">' + escapeHtml(data.title) + '</div>' +
                (data.descriptionHtml ? '<div class="link-preview-description' + truncatedClass + '">' + data.descriptionHtml + '</div>' : '') +
                dateHtml +
            '</div>';
    }

    function escapeHtml(text) {
        var div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
    }

    function positionPreviewCard(link) {
        var rect = link.getBoundingClientRect();
        var cardWidth = 500;
        var cardHeight = previewCard.offsetHeight;
        var padding = 10;
        var left, top;
        var positioned = false;

        // Try positioning on the right
        var rightSpace = window.innerWidth - rect.right - padding;
        if (rightSpace >= cardWidth && !positioned) {
            left = rect.right + padding;

            // Adjust vertical position based on link position in viewport
            var linkVerticalCenter = rect.top + (rect.height / 2);
            var viewportVerticalCenter = window.innerHeight / 2;

            if (linkVerticalCenter < viewportVerticalCenter) {
                // Upper half: align card top with link, but shift down a bit
                top = rect.top - padding;
            } else {
                // Lower half: align card bottom with link, but shift up a bit
                top = rect.bottom - cardHeight + padding;
            }

            // Ensure card stays within viewport
            if (top < padding) {
                top = padding;
            } else if (top + cardHeight > window.innerHeight - padding) {
                top = window.innerHeight - cardHeight - padding;
            }
            positioned = true;
        }

        // Try positioning on the left
        if (!positioned && rect.left - padding >= cardWidth) {
            left = rect.left - cardWidth - padding;

            // Adjust vertical position based on link position in viewport
            var linkVerticalCenter = rect.top + (rect.height / 2);
            var viewportVerticalCenter = window.innerHeight / 2;

            if (linkVerticalCenter < viewportVerticalCenter) {
                // Upper half: align card top with link, but shift down a bit
                top = rect.top - padding;
            } else {
                // Lower half: align card bottom with link, but shift up a bit
                top = rect.bottom - cardHeight + padding;
            }

            // Ensure card stays within viewport
            if (top < padding) {
                top = padding;
            } else if (top + cardHeight > window.innerHeight - padding) {
                top = window.innerHeight - cardHeight - padding;
            }
            positioned = true;
        }

        // Try positioning below
        if (!positioned && window.innerHeight - rect.bottom - padding >= cardHeight) {
            left = rect.left + (rect.width / 2) - (cardWidth / 2);
            top = rect.bottom + padding;

            // Adjust horizontal position to stay within screen bounds
            if (left < padding) {
                left = padding;
            } else if (left + cardWidth > window.innerWidth - padding) {
                left = window.innerWidth - cardWidth - padding;
            }
            positioned = true;
        }

        // Try positioning above
        if (!positioned && rect.top - padding >= cardHeight) {
            left = rect.left + (rect.width / 2) - (cardWidth / 2);
            top = rect.top - cardHeight - padding;

            // Adjust horizontal position to stay within screen bounds
            if (left < padding) {
                left = padding;
            } else if (left + cardWidth > window.innerWidth - padding) {
                left = window.innerWidth - cardWidth - padding;
            }
            positioned = true;
        }

        // Fallback: center below (original behavior)
        if (!positioned) {
            left = rect.left + (rect.width / 2) - (cardWidth / 2);
            top = rect.bottom + padding;

            // Adjust horizontal position to stay within screen bounds
            if (left < padding) {
                left = padding;
            } else if (left + cardWidth > window.innerWidth - padding) {
                left = window.innerWidth - cardWidth - padding;
            }

            // Adjust vertical position if needed
            if (top + cardHeight > window.innerHeight - padding) {
                top = Math.max(padding, window.innerHeight - cardHeight - padding);
            }
        }

        previewCard.style.left = left + window.scrollX + 'px';
        previewCard.style.top = top + window.scrollY + 'px';
    }

    function showPreview(link) {
        if (!previewCard) {
            previewCard = createPreviewCard();
        }

        currentLink = link;
        var url = link.href;

        previewCard.className = 'link-preview-card link-preview-visible';
        previewCard.innerHTML = '';
        positionPreviewCard(link);

        isLoading = true;

        // Show loader only if fetch takes longer than 150ms
        var loaderTimeout = setTimeout(function() {
            if (currentLink === link && isLoading) {
                previewCard.classList.add('link-preview-loading');
                previewCard.innerHTML = '<div class="link-preview-loader"></div>';
            }
        }, 150);

        fetchPostData(url)
            .then(function(data) {
                if (currentLink === link) {
                    clearTimeout(loaderTimeout);
                    updatePreviewCard(data);
                    previewCard.classList.remove('link-preview-loading');
                    positionPreviewCard(link);
                    isLoading = false;
                }
            })
            .catch(function() {
                if (currentLink === link) {
                    clearTimeout(loaderTimeout);
                    hidePreview();
                    isLoading = false;
                }
            });
    }

    function hidePreview() {
        if (!previewCard) return;

        previewCard.classList.remove('link-preview-visible');
        currentLink = null;
        isLoading = false;
    }

    function handleMouseEnter(e) {
        var link = e.currentTarget;

        // Don't show preview on small screens (less than 600px width)
        if (window.innerWidth < 600) {
            return;
        }

        clearTimeout(hideTimeout);
        clearTimeout(showTimeout);

        showTimeout = setTimeout(function() {
            showPreview(link);
        }, SHOW_DELAY);
    }

    function handleMouseLeave() {
        clearTimeout(showTimeout);

        hideTimeout = setTimeout(function() {
            hidePreview();
        }, HIDE_DELAY);
    }

    function handlePreviewMouseEnter() {
        clearTimeout(hideTimeout);
    }

    function handlePreviewMouseLeave() {
        hideTimeout = setTimeout(function() {
            hidePreview();
        }, HIDE_DELAY);
    }

    function initializeLinks(container) {
        if (!container) {
            container = document.querySelector('.single-content, .gh-content, .site-main');
        }
        if (!container) return;

        var links = container.querySelectorAll('a[href]');

        links.forEach(function(link) {
            // Skip if already initialized
            if (link.dataset.linkPreviewInitialized) return;

            if (isInternalPostLink(link)) {
                link.addEventListener('mouseenter', handleMouseEnter);
                link.addEventListener('mouseleave', handleMouseLeave);
                link.classList.add('has-link-preview');
                link.dataset.linkPreviewInitialized = 'true';
            }
        });
    }

    function init() {
        // Initialize links on the page
        initializeLinks();

        // Set up card hover listeners (only once)
        document.addEventListener('mouseenter', function(e) {
            if (e.target.classList && e.target.classList.contains('link-preview-card')) {
                handlePreviewMouseEnter();
            }
        }, true);

        document.addEventListener('mouseleave', function(e) {
            if (e.target.classList && e.target.classList.contains('link-preview-card')) {
                handlePreviewMouseLeave();
            }
        }, true);

        // Watch for dynamically added content (for stacked navigation and pagination)
        var observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
                mutation.addedNodes.forEach(function(node) {
                    if (node.nodeType === 1) { // Element node
                        // Check if it's a stacked page or contains content
                        if (node.classList && (node.classList.contains('stacked-page') ||
                            node.classList.contains('site-main') ||
                            node.classList.contains('gh-content') ||
                            node.classList.contains('feed') ||
                            node.classList.contains('post-card') ||
                            node.classList.contains('post-feed'))) {
                            initializeLinks(node);
                        } else if (node.querySelector) {
                            // Check for content containers within the added node
                            var contentAreas = node.querySelectorAll('.single-content, .gh-content, .site-main, .feed, .post-card, .post-feed');
                            contentAreas.forEach(function(area) {
                                initializeLinks(area);
                            });
                        }
                    }
                });
            });
        });

        // Observe the entire document for dynamically added content
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    // Expose initializeLinks globally for manual initialization if needed
    window.initLinkPreviews = initializeLinks;
})();
